import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { Redirect, Route, Switch } from "wouter";
import { BrandView } from "./brand.view";
import { CreateView } from "./create/create.view";
import { UpdateView } from "./update/update.view";

export function BrandRoutes() {
  const ability = useAbility();
  const brandUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const canManage = ability.can(Action.Manage, "Brand");

  return (
    <Switch>
      <Route path={"/"} component={BrandView} />
      <Route path={"/create"} component={canManage ? CreateView : ReadOnlyRedirect} />
      <Route path={brandUuidRegex} component={canManage ? UpdateView : ReadOnlyRedirect} />
      <Route component={NotFoundView} />
    </Switch>
  );
}

function ReadOnlyRedirect() {
  return <Redirect to="/" replace />;
}
